<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin, BFormInput,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';
import SLSClienteService from '@/services/Cadastros/Cliente/SLSCliente.service';
import ItemModal from '@/views/app/operacoes/picitem/list/ModalBuscarItens.vue';
import ModalBuscarCliente from '@/views/app/operacoes/pic/list/ModalBuscarCliente.vue';

const slsClienteService = new SLSClienteService();

extend('date_after', {
  params: ['target', 'targetName'],
  validate(value, { target }) {
    if (!value || !target) {
      return true;
    }
    const dateValue = new Date(value);
    const dateTarget = new Date(target);
    dateValue.setUTCHours(0, 0, 0, 0);
    dateTarget.setUTCHours(0, 0, 0, 0);

    return dateValue >= dateTarget;
  },
  message: (fieldName, placeholders) => {
    const targetName = placeholders.targetName || 'data de início';
    return `O campo ${fieldName} deve ser igual ou posterior à ${targetName}.`;
  },
});

export default {
  components: {
    ModalBuscarCliente,
    ItemModal,
    BFormInput,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        picid: '',
        picdescricao: '',
        picinformavalorbrutoliquido: '',
        piccontrole: '',
        picsituacao: 'Digitação',
        estabelecimentoid: 1,
        tipopedidoid: '01',
        pictipofrete: 'CIF',
        piciniciovalidade: null,
        picterminovalidade: null,
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      required,
      dataFromApiTipoPicId: null,
      selectedObject: {
        tipopiccliente: false,
        tabelapreco: false,
      },
      dataFromApiTipoPedidoId: null,
      optionsEstabelecimento: [],
      dataFromApiTabelaPreco: [],
      dataFromApiCondicaoPagamento: [],
      dataFromApiCanalVenda: [],
      dataFromApiCliente: [],
      options: [
        {
          label: 'Valor Bruto',
          value: 'B',
        },
        {
          label: 'Valor Liquido',
          value: 'L',
        },
      ],
      optionsTipoFrete: [
        {
          label: 'Selecione um frete',
          value: 'Selecione um frete',
        },
        {
          label: 'CIF',
          value: 'CIF',
        },
        {
          label: 'FOB',
          value: 'FOB',
        },
      ],
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    formattedOptions() {
      return this.optionsEstabelecimento.map((option) => ({
        value: option.estabelecimentoid,
        text: `${option.estabelecimentorazaosocial} (${option.estabelecimentoid})`, // Concatenação de razaosocial com o id
      }));
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
  methods: {
    onModalShow() {
      this.fetchDataFromTipoPic();
      // this.fetchDataFromEstabelecimento()
      // this.fetchDataFromTipoPedido()
      this.fetchDataFromTabelaPreco();
      this.fetchDataFromCanalVenda();
      this.fetchDataFromCondicaoPagamento();
    },
    async validateForm() {
      const isValid = await this.$refs.refFormData.validate();
      if (isValid) {
        this.$emit('ok', this.dataForm);
        await this.limparFormulario();
        this.$bvModal.hide(this.idModal);
      } else {
        console.log('Formulário inválido');
      }
    },
    async toUpperCase() {
      this.dataForm.picid = this.dataForm.picid.toUpperCase();
    },
    async loadingClientes() {
      await slsClienteService.listarClientes();
    },
    async limparFormulario() {
      this.dataForm.picdescricao = '';
      this.dataForm.tipopicid = '';
      this.dataForm.picdatafaturamento = '';
      this.dataForm.piciniciovalidade = '';
      this.dataForm.picterminovalidade = '';
      this.dataForm.picterminovalidadehora = '';
      this.dataForm.estabelecimentoid = 1;
      // this.dataForm.tipopedidoid = '';
      this.dataForm.clienteid = '';
      // this.dataForm.pictipofrete = '';
      this.dataForm.condicaopagamentoid = '';
      this.dataForm.picobservacao = '';
    },
    async fetchDataFromTipoPedido() {
      try {
        const response = await axios.get('/tipo-pedido');
        this.dataFromApiTipoPedidoId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromTabelaPreco() {
      try {
        const response = await axios.get('/tabela-preco');
        this.dataFromApiTabelaPreco = [
          { tabelapreco_id: 0, tabelapreco_descricao: 'Nenhuma' },
          ...response.data.data,
        ];
        this.dataFromApiTabelaPreco = response.data.data.map((option) => ({
          value: option.tabelapreco_id,
          text: `${option.tabelapreco_id}   -  ${option.tabelapreco_descricao} `,
        }));
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromTipoPic() {
      try {
        const response = await axios.get('/tipo-pic');
        this.dataFromApiTipoPicId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromCanalVenda() {
      try {
        const response = await axios.get('/canal-venda');
        this.dataFromApiCanalVenda = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },

    async fetchDataFromCondicaoPagamento() {
      try {
        const response = await axios.get('/condicao-pagamento');
        this.dataFromApiCondicaoPagamento = response.data.data.map((option) => ({
          value: option.condicaopagamentoid,
          text: `${option.condicaopagamentoid}  -  ${option.condicaopagamentodescricao}`,
        }));
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromEstabelecimento() {
      try {
        const response = await axios.get('/estabelecimento');
        this.optionsEstabelecimento = response.data.data.map((option) => ({
          value: option.estabelecimentoid,
          text: `${option.estabelecimentorazaosocial} - ${option.estabelecimentoid}`,
        }));
      } catch (error) {
        console.error('Erro ao buscar estabelecimentos:', error);
      }
    },
    updateSelectedObject() {
      this.selectedObject = this.dataFromApiTipoPicId.find((option) => option.tipopicid === this.dataForm.tipopicid);
      console.log('Selected Object:', this.selectedObject);
    },
    showModalCliente() {
      this.$refs.clienteModal.show();
    },
    updateClienteId(selectedItem) {
      console.log('selectedItem', selectedItem);
      this.$set(this.dataForm, 'clienteid', selectedItem.value);
      this.$set(this.dataForm, 'clientenomefantasia', selectedItem.text);
    },

  },
};
</script>

<template>
  <b-modal no-close-on-backdrop no-close-on-esc size="xl" :id="idModal" :title="titleModal" :ok-title="labelBtnOk"
    ok-variant="success" cancel-variant="secondary" body-bg-variant="light" cancel-title="Cancelar" @ok.prevent="validateForm"
    @cancel="$emit('cancel'); limparFormulario()" @close="$emit('cancel'); limparFormulario()">
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Descrição" label-for="picdescricao">
              <validation-provider #default="{ errors }" name="Descrição" rules="required">
                <b-form-input v-model="dataForm.picdescricao" id="picdescricao"
                  :state="errors.length > 0 ? false : null" placeholder="Digite a descrição" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Tipo Pic" label-for="tipopicid">
              <validation-provider #default="{ errors }" name="Tipo Pic " rules="required">
                <b-form-select v-model="dataForm.tipopicid" id="tipopicid"
                  :options="[{ tipopicid: null, tipopicdescricao: 'Selecione um Tipo Pic' }, ...dataFromApiTipoPicId]"
                  value-field="tipopicid" text-field="tipopicdescricao" :state="errors.length > 0 ? false : null"
                  placeholder="Digite o código" @change="updateSelectedObject" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Data Faturamento" label-for="picdatafaturamento">
              <validation-provider #default="{ errors }" name="Data Faturamento" rules="required">
                <b-form-input v-model="dataForm.picdatafaturamento" id="picdatafaturamento"
                  :state="errors.length > 0 ? false : null" type="date" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Validade Início" label-for="piciniciovalidade">
              <validation-provider #default="{ errors }" name="Validade Início" rules="required" vid="piciniciovalidade">
                <b-form-input v-model="dataForm.piciniciovalidade" id="piciniciovalidade"
                  :state="errors.length > 0 ? false : null" type="date" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Validade Término" label-for="picterminovalidade">
              <validation-provider #default="{ errors }" name="Validade Término" :rules="{ required: true, date_after: ['@piciniciovalidade', 'Data Início'] }">
                <b-form-input v-model="dataForm.picterminovalidade" id="picterminovalidade"
                  :state="errors.length > 0 ? false : null" type="date" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Hora" label-for="picterminovalidadehora">
              <validation-provider #default="{ errors }" name="Hora" rules="required">
                <b-form-input v-model="dataForm.picterminovalidadehora" id="picterminovalidadehora"
                  :state="errors.length > 0 ? false : null" type="time" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <modal-buscar-cliente @select-cliente="updateClienteId" ref="clienteModal" />
          <b-col cols="4" class="mb-1" v-if="selectedObject.tipopiccliente">
            <b-form-group label="Cliente" label-for="clienteid">
              <validation-provider #default="{ errors }" name="Cliente" rules="required">
                <b-input-group>
                  <b-form-input v-model="dataForm.clientenomefantasia" id="clienteid"
                    :state="errors.length > 0 ? false : null" disabled />
                  <b-input-group-append>
                    <b-button @click="showModalCliente"><feather-icon icon="SearchIcon" /></b-button>
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Tabela Preço" label-for="tabelapreco">
              <validation-provider #default="{ errors }" name="Tabela Preço" rules="required">
                <v-select v-model="dataForm.tabelaprecoid" :options="dataFromApiTabelaPreco" label="text"
                  :reduce="option => option.value" :clearable="false" placeholder="Selecione"
                  :state="errors.length > 0 ? false : null" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Condição Pagamento" label-for="condicaopagamentoid">
              <validation-provider #default="{ errors }" name="Condição Pagamento" rules="required">
                <v-select v-model="dataForm.condicaopagamentoid" :options="dataFromApiCondicaoPagamento" label="text"
                  :reduce="option => option.value" :clearable="false" placeholder="Selecione"
                  :state="errors.length > 0 ? false : null" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Estabelecimento" label-for="estabelecimentoid">
              <validation-provider #default="{ errors }" name="Estabelecimento" rules="required">
                <b-form-input value="HANESBRANDS BRASIL TEXTIL LTDA." id="estabelecimentoid"
                  :state="errors.length > 0 ? false : null" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Tipo Pedido" label-for="tipopedidoid">
              <validation-provider #default="{ errors }" name="Tipo Pedido" rules="required">
                <b-form-input value="VENDA PRODUÇÃO PRÓPRIA" id="tipopedidoid" :state="errors.length > 0 ? false : null"
                  disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Tipo Frete" label-for="pictipofrete">
              <validation-provider #default="{ errors }" name="Tipo Frete" rules="required">
                <b-form-input value="CIF" id="pictipofrete" :state="errors.length > 0 ? false : null" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" class="mb-1">
            <b-form-group label="Observação" label-for="picobservacao">
              <validation-provider #default="{ errors }" name="Observação">
                <b-form-textarea v-model="dataForm.picobservacao" id="picobservacao"
                  :state="errors.length > 0 ? false : null" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
